<template>
    <Select v-model="language" :options="locales" optionLabel="name" @update:model-value="changeLocale">
        <template #dropdownicon>
            <i class="pi pi-language" />
        </template>
    </Select>
</template>
<script setup lang="ts">
import { useLocaleSettings } from "@/composables/localeSettings";
import LookupListItem from "@/types/lookup/LookupListItem";
import {  onMounted, ref } from "vue";

const localeHelper = useLocaleSettings();
const language = ref({} as LookupListItem);
const locales = ref(Array<LookupListItem>());
onMounted(() => {    
  locales.value = localeHelper.GetLocales();
  language.value = localeHelper.GetCurrentLocale();
})

const changeLocale = () => {  
    localeHelper.ChangeLocale(language.value!)
}
</script>